import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import authReducer from './auth/auth.slice';
import { authApi } from './auth/auth.api';
import { usersApi } from './users/users.api';
import { eventsApi } from './events/events.api';
import { clubsApi } from './clubs/clubs.api';
import { settingsApi } from './settings/settings.api';
import { candidatesApi } from './candidates/candidates.api';
import { coversApi } from './covers/covers.api';
import { whatsNewApi } from './whatsNew/whatsNew.api';
import { payoutsApi } from './payouts/payouts.api';
import { analyticsApi } from './analytics/analytics.api';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [authApi.reducerPath]: authApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [eventsApi.reducerPath]: eventsApi.reducer,
    [clubsApi.reducerPath]: clubsApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
    [candidatesApi.reducerPath]: candidatesApi.reducer,
    [coversApi.reducerPath]: coversApi.reducer,
    [whatsNewApi.reducerPath]: whatsNewApi.reducer,
    [payoutsApi.reducerPath]: payoutsApi.reducer,
    [analyticsApi.reducerPath]: analyticsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      usersApi.middleware,
      eventsApi.middleware,
      clubsApi.middleware,
      settingsApi.middleware,
      candidatesApi.middleware,
      coversApi.middleware,
      whatsNewApi.middleware,
      payoutsApi.middleware,
      analyticsApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
